<template>
  <v-app>
    <v-app-bar v-if="!$route.meta?.hideAppBar && !$route.path?.includes('print') && !$route.path?.includes('file')" app>
      <v-icon v-if="$route.name?.includes('search')" class="search-icon">mdi-magnify</v-icon>
      <v-toolbar-title v-if="!$route.path?.includes('login')">
        {{ $route.path?.includes('search') ? $t('titleBackEnd') : $t('titleFrontEnd') }}
      </v-toolbar-title>
      <v-toolbar-title v-else></v-toolbar-title>
      <v-btn v-if="!$route.name?.includes('search')" @click="changeLanguage('en')">English</v-btn>
      <v-btn v-if="!$route.name?.includes('search')" @click="changeLanguage('zh')">中文</v-btn>
      <v-btn v-if="showLogoutButton" @click="logout">{{ $t('logout') }}</v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { logUserAction } from '@/service/logService';

export default {
  data() {
    return {
      showLogoutButton: false,
    };
  },
  methods: {
    async changeLanguage(lang) {
      this.$i18n.locale = lang;
      const token = localStorage.getItem('jwtToken');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const uniqueName = payload.unique_name;
        await logUserAction('changeLanguage', uniqueName, `Language changed to ${lang}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    },
    async logout() {
      const token = localStorage.getItem('jwtToken');

            try {
        if (token) {
          const payload = JSON.parse(atob(token.split('.')[1]));
          const uniqueName = payload.unique_name;
          // 等待日誌記錄完成
          await logUserAction('logout', uniqueName, 'User logged out', {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
        }
      } catch (error) {
        // 即使日誌記錄失敗，也應該繼續登出流程，所以只在控制台打印錯誤
        console.error('Error logging user action during logout:', error);
      } finally {
        // 無論日誌記錄是否成功，都執行清理和導航
        localStorage.removeItem('username');
        localStorage.removeItem('jwtToken');
        this.showLogoutButton = false; // 登出後隱藏按鈕
        this.$router.push('/');
      }

      //localStorage.removeItem('username');
      //localStorage.removeItem('jwtToken');
      //this.$router.push('/');
    }
  },
  async created() {
    this.$i18n.locale = 'zh';

    this.$router.beforeEach(async (to, from, next) => {
      this.showLogoutButton = to.path === '/basic';

      const token = localStorage.getItem('jwtToken');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const uniqueName = payload.unique_name;
        await logUserAction('navigate', uniqueName, `Navigated from ${from.path} to ${to.path}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      next();
    });

    this.showLogoutButton = this.$router.currentRoute.value?.path === '/basic';
  }
};
</script>

<style>
/* 禁用 Google 字體，改用本地字體 */
@font-face {
  font-family: 'Material Design Icons';
  src: url('./fonts/materialdesignicons-webfont.woff2') format('woff2'),
       url('./fonts/materialdesignicons-webfont.woff') format('woff'),
       url('./fonts/materialdesignicons-webfont.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: Arial, sans-serif; /* 使用本地字體 */
}

.v-icon {
  font-family: 'Material Design Icons', sans-serif; /* 使用本地 Material Design Icons 字體 */
}

.search-icon {
  margin-left: 16px;
}
</style>